import { APIcaller } from '../APIcaller';

const getAllCSMs = async () => APIcaller.apiGet(`/backoffice/inpulse-csm-accounts`);

const getCsmManagerByClientId = async (clientId) =>
  APIcaller.apiGet(`/backoffice/clients/${clientId}/inpulse-accounts`);

const upsertCsmManagerByClientId = async (clientId, inpulseAccountId) =>
  APIcaller.apiPost(`/backoffice/clients/${clientId}/inpulse-accounts`, {
    inpulseAccountId,
  });

export default { getAllCSMs, getCsmManagerByClientId, upsertCsmManagerByClientId };
